
import { defineComponent, reactive } from 'vue'
import Modal from '@/common/components/UI/Modal/index.vue'
import FileReader from '@/common/components/UI/FileReader/index.vue'
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { useFormData } from '@/common/composable/useFormData'
import { ftl_bids } from '@/core/realisations/ftl_bids.realisation'
import useNotifications from '@/common/composable/useNotifications'

export default defineComponent({
    components: {
        Modal,
        FileReader,
    },
    props: {
        orderId: {
            type: String,
            required: true,
        },
    },
    emits: ['cancel', 'submit'],
    setup(props, { emit }) {
        const { getFormData } = useFormData()
        const notifications = useNotifications()

        const state = reactive({
            is_loading: false,
            file: [] as File[],
        })

        const state_form$ = useVuelidate(
            {
                file: { required },
            },
            state
        )

        const emitCancel = () => {
            if (state.is_loading) return
            emit('cancel')
        }

        const emitSubmit = async () => {
            state_form$.value.$touch()
            if (state.is_loading || state_form$.value.$invalid) return

            try {
                state.is_loading = true

                const payload = { file: state.file[0] }
                await ftl_bids.exportDeclaration(Number(props.orderId), getFormData(payload))

                notifications.notify({
                    title: 'Статус успешно изменен',
                    type: 'success',
                })
                
                emit('submit')
            } catch (error) {
                notifications.notifyError({
                    error,
                    title: 'При изменении статуса произошла ошибка!',
                })
            } finally {
                state.is_loading = false
            }
        }

        return {
            state,
            state_form$,
            emitCancel,
            emitSubmit,
        }
    },
})
